<template>
  <v-container fluid class="my-5">
    <MesaDirectivaVotaciones />
  </v-container>
</template>

<script>
import MesaDirectivaVotaciones from '@/components/mesaDirectiva/MesaDirectivaVotaciones.vue'

export default {
  name: 'mesa_directiva_votaciones',
  components: {
    MesaDirectivaVotaciones
  }
}
</script>
